<h3 mat-dialog-title>Details for task <strong>{{data.name}}</strong></h3>
<div mat-dialog-content>
  <dx-data-grid [dataSource]="dataSource"
                [remoteOperations]="false"
                [allowColumnReordering]="true"
                [rowAlternationEnabled]="true"
                [showBorders]="true"
                [searchPanel]="searchPanel"
                [columnAutoWidth]="false"
                [width]="'100%'"
                (onContentReady)="onGridReady($event)">
    <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
  </dx-data-grid>

</div>
<mat-divider></mat-divider>
<div mat-dialog-actions class="actions">
  <button mat-raised-button (click)="onYesClick()" color="accent" >Close</button>
</div>
